import React, { useState } from 'react';
import { useLocation, useNavigate } from '../nav';
import { CustomIcon } from '../components/CustomIcons';
import { paymentQuery, readPayment } from '../lib/transfer';
export function Review() {
  const navigate = useNavigate();
  const {
    pathname,
    search
  } = useLocation();
  const payment = readPayment(pathname + search);
  const [pressed, setPressed] = useState(false);
  const query = payment.isBill ? `bill=${encodeURIComponent(payment.bill || '')}` : paymentQuery(payment);
  const confirm = () => {
    setPressed(true);
    window.setTimeout(() => navigate(`/success?${query}`), 520);
  };
  return <main className="flex h-full w-full flex-col bg-[#061827] text-white" data-id="element-632" data-mp="2jf9hlyee2jfn">
      <header className="flex items-center gap-3 border-b border-white/10 px-5 pb-4 pt-14" data-id="element-633" data-mp="2eelw1s8xiust">
        <button onClick={() => navigate(-1)} className="flex h-10 w-10 items-center justify-center rounded-xl bg-white/10" aria-label="Back" data-id="element-634" data-mp="3ut4zvg0lb8b3">←</button>
        <div data-id="element-635" data-mp="3ptsgj58xgjd9">
          <p className="text-[10px] font-extrabold uppercase tracking-[.16em] text-brand-electric" data-id="element-636" data-mp="3pweimpd1u6o3">Final check</p>
          <h1 className="mt-1 text-lg font-extrabold" data-id="element-637" data-mp="31qy27ujzvqof">Review and confirm</h1>
        </div>
      </header>

      <section className="phone-scroll flex-1 overflow-y-auto px-5 py-5" data-id="element-638" data-mp="36q16hcs5hsvc">
        <div className="rounded-[30px] bg-[linear-gradient(145deg,#132e52,#246BFE_70%,#6747E8)] p-5 shadow-glow" data-id="element-639" data-mp="36nwu06g6rljg">
          <p className="text-xs font-bold uppercase tracking-[.14em] text-blue-100" data-id="element-640" data-mp="3ap9yod7jlios">Total debit</p>
          <p className="mt-2 text-[43px] font-extrabold tracking-[-.06em] tabular-nums" data-id="element-641" data-mp="2dziypyghf3bl">₦{payment.amount}</p>
          <p className="mt-2 text-xs leading-relaxed text-blue-100" data-id="element-642" data-mp="2n21trwe10bna">This amount will leave your VE Bank Account only after you confirm with biometrics.</p>
        </div>

        <article className="mt-5 rounded-[27px] bg-white p-5 text-brand-navy shadow-float" data-id="element-643" data-mp="2ru1u3py0d6ke">
          <div className="flex items-center justify-between border-b border-slate-100 pb-4" data-id="element-644" data-mp="1vam1blpsfup5">
            <div className="min-w-0" data-id="element-645" data-mp="1zawi7tf4c5is">
              <p className="text-[10px] font-extrabold uppercase tracking-[.15em] text-brand-slate" data-id="element-646" data-mp="32nda5kai2kgu">Recipient or service</p>
              <h2 className="mt-1 truncate text-lg font-extrabold" data-id="element-647" data-mp="2xp229f3rmk19">{payment.party}</h2>
            </div>
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-brand-cloud text-brand-cobalt" data-id="element-648" data-mp="3cdg2rjdplwen"><CustomIcon name={payment.icon} size={19} data-id="element-649" data-mp="37feiww8glt24" /></span>
          </div>
          <dl className="mt-4 space-y-3.5" data-id="element-650" data-mp="2jnpl50cvccds">
            <Row label="Source account" value="VE Bank Account · 0803 123 4567" data-id="element-651" data-mp="2jor8o4b2mrce" />
            <Row label="Recipient" value={payment.isBill ? payment.party : `${payment.party} · ${payment.account}`} data-id="element-652" data-mp="2eqpnndu34hya" />
            <Row label="Bank" value={payment.bank} data-id="element-653" data-mp="2sqiauz6ekg1i" />
            <Row label="Amount" value={`₦${payment.amount}`} data-id="element-654" data-mp="2onca27227h2f" />
            <Row label="Fee" value="₦0.00" data-id="element-655" data-mp="2opygu4h4lsjl" />
            <Row label="Narration" value={payment.narration} data-id="element-656" data-mp="7xx2rb4sqtqp" />
            <Row label="Total debit" value={`₦${payment.amount}`} strong data-id="element-657" data-mp="3xd4u5cefm3i" />
            <Row label="After confirmation" value="Your balance updates immediately." data-id="element-658" data-mp="3zfu2n5q9b76" />
          </dl>
        </article>

        <p className="mt-5 px-2 text-center text-[11px] leading-relaxed text-slate-400" data-id="element-659" data-mp="gfyzwg01iltk">Vee prepared this information. Vee cannot approve, confirm, or complete this payment.</p>
      </section>

      <footer className="border-t border-white/10 bg-[#071f37] p-5" data-id="element-660" data-mp="1l2ltm5jv48k">
        <button onClick={confirm} disabled={pressed} className={`flex min-h-[56px] w-full items-center justify-center gap-3 rounded-2xl text-sm font-extrabold transition ${pressed ? 'bg-brand-electric text-brand-navy' : 'bg-white text-brand-navy'}`} data-id="element-661" data-mp="6ib2fib1v07p">
          <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-brand-cobalt text-white" aria-hidden="true" data-id="element-662" data-mp="ki3srcinzef5">◉</span>
          {pressed ? 'Authenticating…' : 'Confirm with biometrics'}
        </button>
      </footer>
    </main>;
}
function Row({
  label,
  value,
  strong = false
}: {
  label: string;
  value: string;
  strong?: boolean;
}) {
  return <div className="flex items-start justify-between gap-4" data-id="element-663" data-mp="1hz13kn0m91ug">
      <dt className="max-w-[105px] text-[11px] font-bold text-brand-slate" data-id="element-664" data-mp="3qf24ce3liz6r">{label}</dt>
      <dd className={`max-w-[190px] text-right text-xs ${strong ? 'font-extrabold text-brand-cobalt' : 'font-bold text-brand-navy'}`} data-id="element-665" data-mp="3leo7ls7g3bo1">{value}</dd>
    </div>;
}